'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _querystring = require('querystring');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailShare = function (_React$Component) {
	(0, _inherits3.default)(EmailShare, _React$Component);

	function EmailShare(props) {
		(0, _classCallCheck3.default)(this, EmailShare);

		var _this = (0, _possibleConstructorReturn3.default)(this, (EmailShare.__proto__ || Object.getPrototypeOf(EmailShare)).call(this, props));

		_this.state = {
			email: props.email,
			subject: props.subject,
			body: props.body
		};
		return _this;
	}

	(0, _createClass3.default)(EmailShare, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (!this.state.body) {
				this.setState({
					body: document.location.href
				});
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps) {
			if (this.props.email !== prevProps.email) {
				this.setState({
					email: this.props.email
				});
			}
			if (this.props.body !== prevProps.body) {
				this.setState({
					body: this.props.body
				});
			}
			if (this.props.subject !== prevProps.subject) {
				this.setState({
					subject: this.props.subject
				});
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var query = {};
			if (this.state.subject) query.subject = this.state.subject;
			if (this.state.body) query.body = this.state.body;
			return this.props.children('mailto:' + (this.state.email || '') + '?' + (0, _querystring.stringify)(query));
		}
	}]);
	return EmailShare;
}(_react2.default.Component);

EmailShare.propTypes = {
	body: _propTypes2.default.string,
	email: _propTypes2.default.string,
	subject: _propTypes2.default.string
};

exports.default = EmailShare;
module.exports = exports['default'];